export const tags = [['RadiopharmaceuticalInfo', '00540016']];
